import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import Seoinspect from "./Seoinspect";
import Inspect1 from "../Images/inspect1.png";
import Inspect2 from "../Images/inspect2.png";
import Inspect3 from "../Images/inspect3.png";
import Inspect4 from "../Images/inspect4.png";
import Loader from "../Images/aivideo.gif";
const cardData = [
  {
    title: "Instant Domain Health Check",
    text: "With just one click, Seobix scans your entire site and gives you a real-time SEO health score. Whether you're an agency, blogger, or small business owner.",
    image: Inspect1,
  },
  {
    title: "Built for Growth, Not Just Analysis",
    text: "Seobix is more than a checker—it’s your roadmap to better rankings. Whether you’re optimizing blog content, improving or targeting new keywords, our insights turn into real performance.",
    image: Inspect2,
  },
  {
    title: "Website SEO Scanning",
    text: "No more waiting or loading bars. Seobix scans your website in just a few seconds and gives you a detail of your SEO performance—so you can act fast and rank faster.",
    image: Inspect3,
  },
];

const Inspectnow = () => {
  const [URL, setURL] = useState("");
  const [seoData, setSeoData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (url) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://api.seobix.com/api/Seo/GetSeoScore`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ url }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      setSeoData(data);
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAnalyzeClick = () => {
    if (URL.trim() === "") {
      alert("Please enter a valid URL.");
      return;
    }
    let formattedURL = URL.trim();
    if (!/^https?:\/\//i.test(formattedURL)) {
      formattedURL = `https://${formattedURL}`;
    }

    fetchData(formattedURL);
  };
  const seoSectionRef = useRef(null);
  useEffect(() => {
    if (seoData && seoSectionRef.current) {
      seoSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [seoData]);

  return (
    <Container
      fluid
      className="p-0 "
      style={{ overflowX: "hidden", scrollbarWidth: "none" }}
    >
      {isLoading && <div className="dimming-overlay"><img src={Loader}/></div>}
      <Nav />

      <Row className="d-flex justify-content-center mt-4 mb-5 ">
        <Col className="col-md-10 col-12">
          <h1 className="text-center" style={{ color: "rgb(0, 51, 102)" }}>
            SEO Analyzer
          </h1>
          <p className="mb-0 text-center" style={{ color: "rgb(0, 51, 102)" }}>
            <b>Get a Detailed SEO Breakdown Instantly</b>
          </p>
          <p className="text-center mb-4" style={{ color: "rgb(0, 51, 102)" }}>
            Check your website's health and receive data-driven tips to boost
            performance.
          </p>
          <div className="d-flex justify-content-center m-5">
            <div className="position-relative" style={{ width: "30vw" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter URL e.g. https://google.com"
                value={URL}
                onChange={(e) => setURL(e.target.value)}
                style={{
                  borderRadius: "50px",
                  height: "3rem",
                }}
              />
              <button
                type="submit"
                className="btn position-absolute"
                style={{
                  top: "50%",
                  right: "0.5rem",
                  transform: "translateY(-50%)",
                  borderRadius: "50px",
                  background: "rgb(175, 221, 255) 0%",
                  color: "rgb(0, 51, 102)",
                  fontWeight: "bold",
                }}
                onClick={handleAnalyzeClick}
              >
                ANALYZE
              </button>
            </div>
          </div>
          <h2 className="text-center mb-5" style={{ color: "rgb(0, 51, 102)" }}>
            The Benefits You’ll Get with Seobix SEO Analyzer
          </h2>
          <Row className="mb-4">
            {cardData.map((card, index) => (
              <Col md={4} key={index}>
                <Card className="mb-4 shadow-sm h-100 p-2 border-0">
                  <div
                    className="mb-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Card.Img
                      variant="top"
                      src={card.image}
                      alt={card.title}
                      style={{ width: "5rem" }}
                    />
                  </div>
                  <h5 className="text-center">{card.title}</h5>
                  <Card.Text
                    className="text-center"
                    style={{ fontSize: ".9rem" }}
                  >
                    {card.text}
                  </Card.Text>
                </Card>
              </Col>
            ))}
          </Row>
          {!seoData && (
            <>
              <h3
                className="text-center mt-3"
                style={{ color: "rgb(0, 51, 102)" }}
              >
                Smarter SEO Starts Here
              </h3>
              <p
                className="text-center mb-5"
                style={{ color: "rgb(0, 51, 102)" }}
              >
                From technical SEO to keyword tracking, Seobix brings it all
                together. Take the guesswork
                <br /> out of ranking and let real data guide your growth.
              </p>
              <div className="d-flex justify-content-center">
                <img
                  variant="top"
                  src={Inspect4}
                  alt="seobix"
                  style={{ width: "" }}
                />
              </div>
            </>
          )}
          {seoData && (
            <div
              ref={seoSectionRef}
              className="mb-5"
              style={{
                animation: "fadeInUp 0.6s ease-out",
                animationFillMode: "both",
              }}
            >
              <Seoinspect seoData={seoData} />
            </div>
          )}
        </Col>
      </Row>

      {!seoData && (
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      )}
    </Container>
  );
};

export default Inspectnow;
